import React from 'react'
import { FixModal } from '@elamajs/ui-kit'

import { useMediaQuery } from '../../hooks'
import * as Styled from './ThemeClassifierModal.styled'

type Props = {
  data: { title: string; description: string }[]
  isOpen: boolean
  onClose: () => void
}

const ThemeClassifierModal: React.FC<Props> = ({ data, isOpen, onClose }) => {
  const displayType = useMediaQuery()

  const getModalWidth = () => {
    switch (displayType) {
      case 'large':
        return 1160
      case 'laptop':
        return 920
      case 'tablet':
        return 728
      case 'mobile':
      default:
        return 290
    }
  }

  const modalWidth = getModalWidth()

  return (
    <Styled.Modal as={FixModal} isOpened={isOpen} width={modalWidth} onRequestClose={onClose}>
      <FixModal.Header>
        <Styled.ModalTitle>Классификатор тематик</Styled.ModalTitle>
      </FixModal.Header>
      <FixModal.Content>
        <Styled.List>
          {data.map(({ title, description }, index) => (
            <Styled.Row key={index}>
              <Styled.Title>{title}</Styled.Title>
              <Styled.Description>{description}</Styled.Description>
            </Styled.Row>
          ))}
        </Styled.List>
      </FixModal.Content>
    </Styled.Modal>
  )
}
export default ThemeClassifierModal
